import React, { useState, useEffect } from "react";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import "./Planner.css"
import Heading6Regular from "../designSystem/Heading6Regular";
import CustomCalendar from "./Calendar.jsx";
import ViewDrawer from "./ViewDrawer";
import AddDrawer from "./AddDrawer";
import CopyModal from "./CopyPlanModal";
import CreateTaskModal from "./CreateTaskModal";
import ClearPlanModal from "./ClearPlanModal";
import { useSelector } from "react-redux";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay.jsx";
import PastePlanDrawer from "../Copy Planner/PastePlanDrawer.jsx";
import PasteConfirmationModal from "../Copy Planner/PasteConfirmationModal.jsx";
import { useDispatch } from "react-redux";
import { addEmployeePlan, getEmployeePlan } from "../../actions/userActions/EmployeePlanAction.js";
const Planner = () => {
    const DRAFT = 1;
    const NEEDSREVISION = 4;
    const dispatch = useDispatch();
    const [isViewDrawerOpen, setIsViewDrawerOpen] = useState(false);
    const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);
    const [isCopyModalVisible, setIsCopyModalVisisble] = useState(false);
    const [isCreateTaskModalVisible, setIsCreateTaskModalVisisble] = useState(false);
    const [isClearPlanModalVisible, setIsClearPlanModalVisisble] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);
    const [currentDate, setCurrentDate] = useState(new Date());
    const pasteMonth = currentDate.getMonth() + 1;
    const pasteYear = currentDate.getFullYear();

    const [eventsForSelectedDay, setEventsForSelectedDay] = useState(null);
    const [isPasteDrawerOpen, setIsPasteDrawerOpen] = useState(false);
    const [isPasteModalOpen, setIsPasteModalOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.result[0]?.user?.id;
    const [permissions, setPermissions] = useState([]);
    const isLoading = useSelector((state) => state.employeePlan_reducer.isEmployeePlanLoading);

useEffect(() => {
  const storedPermissions = JSON.parse(localStorage.getItem('permissionsList') || '[]');
  setPermissions(storedPermissions);
}, []);


    const onViewDrawerClose = () => {
        setIsViewDrawerOpen(false);
    };
    const onAddDrawerClose = () => {
        setIsAddDrawerOpen(false);
    };
    const onCopyModalClose = () => {
        setIsCopyModalVisisble(false);
    };
    const onCreateTaskModalClose = () => {
        setIsCreateTaskModalVisisble(false);
    };
    const onClearPlanModalClose = () => {
        setIsClearPlanModalVisisble(false);
    };

    const handlePasteClick = () => {
  // setIsPasteDrawerOpen(false); 
    setIsPasteDrawerOpen(true); 

};
const isPlannerOpen = (day) => {
  const today = new Date();
  const clickedDate = new Date(day.year, day.month - 1, day.day);
  const hasUnrestricted = permissions?.includes("AllowUnrestrictedPlannerAccess");
  const hasAddPlan = permissions?.includes("CanAddPlan");

  if (hasUnrestricted && hasAddPlan) {
    return true;
  }
  if (hasAddPlan) {
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    const todayDate = today.getDate();
    const isNextMonth =
      clickedDate.getMonth() === (currentMonth + 1) % 12 &&
      clickedDate.getFullYear() === (currentMonth === 11 ? currentYear + 1 : currentYear);
    if (!isNextMonth) {
      return false; 
    }
    if (todayDate >= 15 && todayDate <= 25) {
      return true;
    }
    return false;
  }
  return false;
};

const handleDayClick = (day, events, planStatus) => {
  setSelectedDay(day);
  setEventsForSelectedDay(events);

  // ✅ Always allow viewing if permission exists
  if (permissions.includes("CanViewPlan")) {
    // Open ViewDrawer for non-draft plans
    if (planStatus !== DRAFT && planStatus !== NEEDSREVISION && events !== undefined) {
      setIsViewDrawerOpen(true);
      return;
    }
  }

  // ✅ Allow AddDrawer only if user can add and planner is open
  if (
    permissions.includes("CanAddPlan") &&
    isPlannerOpen(day) &&
    (planStatus === DRAFT || planStatus === NEEDSREVISION)
  ) {
    setIsAddDrawerOpen(true);
    return;
  }

  console.log("User does not have permission to add/view this plan.");
};


    const handlePasteModalOpen = () => {
  setIsPasteModalOpen(true);
};

const handlePasteModalClose = () => {
  setIsPasteModalOpen(false);
};

const handleFinalPaste = async () => {
  const copiedData = JSON.parse(localStorage.getItem("copiedPlanData") || "[]");
  const targetDatesSelected = JSON.parse(localStorage.getItem("targetPlanDates") || "{}");

  if (copiedData.length === 0 || Object.keys(targetDatesSelected).length === 0) {
    console.log("Missing copied data or target dates");
    return;
  }

  try {
    for (let i = 0; i < copiedData.length; i++) {
      const copiedPlan = copiedData[i];
      const targetDateRaw = targetDatesSelected[i];

      if (!targetDateRaw) continue;

      const targetDate = new Date(targetDateRaw);
      const yyyy = targetDate.getFullYear();
      const mm = String(targetDate.getMonth() + 1).padStart(2, "0");
      const dd = String(targetDate.getDate()).padStart(2, "0");
      const formattedDate = `${yyyy}-${mm}-${dd}`;

      const filteredPlanDetails = copiedPlan.planDetails;

      if (!filteredPlanDetails || filteredPlanDetails.length === 0) {
        console.log(`Skipping paste: Empty or invalid planDetails at index ${i}`, copiedPlan);
        continue;
      }

      const visitProfileId = copiedPlan?.planDetails?.[0]?.visitProfileId ?? null;

      const payload = {
        employeePlanId: 0,
        employeeId: userId,
        month: targetDate.getMonth() + 1,
        year: targetDate.getFullYear(),
        employeePlanDate: {
          employeePlanDateId: 0,
          planDate: `${yyyy}-${mm}-${dd}`,
          visitProfileId: visitProfileId,
          onLeave: false,
          leaveMessage: "",
          planDetails: filteredPlanDetails.map(detail => ({
            id: 0,
            cityId: detail.cityId,
            startTime: detail.startTime,
            endTime: detail.endTime,
            practiceLocationId: detail.practiceLocationId,
            doctorId: detail.doctorId,
            headOffice: detail.headOffice
          }))
        }
      };

      console.log("Dispatching Paste Plan", copiedData);

      const result = await dispatch(addEmployeePlan(payload));
      console.log("Paste Result for date:", formattedDate, JSON.stringify(result, null, 2));
    }

    localStorage.removeItem("copiedPlanData");
    localStorage.removeItem("targetPlanDates");
  
    setIsPasteModalOpen(false);
    setIsPasteDrawerOpen(false);
    dispatch(getEmployeePlan(userId, pasteMonth, pasteYear));
  } catch (error) {
    console.error("Paste failed with error:", error);
    toast.error("Something went wrong while pasting the plan.");
  }
};

    return (
        <>
        <LoadingOverlay isVisible={isLoading} />
        <div className="planner-container">
              <div className="">
                <CustomCalendar isPlannerOpen = {isPlannerOpen}
                 onDayClick={handleDayClick} onPasteClick={handlePasteClick} currentDate={currentDate}
                setCurrentDate={setCurrentDate}/>
            </div>
            <ViewDrawer isOpen={isViewDrawerOpen} day={selectedDay} events={eventsForSelectedDay} onClose={onViewDrawerClose} />
            <AddDrawer isOpen={isAddDrawerOpen} day={selectedDay} events={eventsForSelectedDay} onClose={onAddDrawerClose} />
            {isPasteDrawerOpen && (
                <PastePlanDrawer isOpen={isPasteDrawerOpen} onClose={() => setIsPasteDrawerOpen(false)} pasteMonth={pasteMonth} pasteYear={pasteYear} onPasteClick={handlePasteModalOpen}/>
            )}
            <CopyModal isVisible={isCopyModalVisible} onClose={onCopyModalClose} />
            <CreateTaskModal isVisible={isCreateTaskModalVisible} onClose={onCreateTaskModalClose} />
            <ClearPlanModal isVisible={isClearPlanModalVisible} onClose={onClearPlanModalClose} />
            <PasteConfirmationModal 
             isVisible={isPasteModalOpen}
             onClose={handlePasteModalClose}
             onConfirm={handleFinalPaste}
            />
        </div>
        </>
    )
}

export default Planner;